<template>
<div class="full-wrapper pannel">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <w-operation-state-info :params="params" :rsc-info="operationStateParams" :active="active"></w-operation-state-info>
      <el-row>
        <div class="row">
          <el-col :md="12" :lg="12">
            <w-perf-widget :show-change-btn="false">
              <span slot="perfHeader">구성 정보</span>
              <div slot="perfBody">
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>장비명</th>
                      <td>{{ configInfoData.objName }}</td>
                    </tr>
                    <tr>
                      <th>IP</th>
                      <td>{{ configInfoData.ipaddress ? configInfoData.ipaddress : '-' }}</td>
                    </tr>
                    <tr>
                      <th>OS종류</th>
                      <td>{{ configInfoData.osName ? configInfoData.osName : '-' }}</td>
                    </tr>
                    <tr>
                      <th>서비스팩</th>
                      <td>{{ configInfoData.osServicepackVer ? configInfoData.osServicepackVer : '-' }}</td>
                    </tr>
                  </table>
                </el-col>
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>시스템 종류</th>
                      <td>{{ configInfoData.osArchtecture ? configInfoData.osArchtecture : '-' }}</td>
                    </tr>
                    <tr>
                      <th>구동 시간</th>
                      <td>{{ configInfoData.uptime ? configInfoData.uptime : '정보가 수집되지 않았습니다.' }}</td>
                    </tr>
                    <!-- <tr>
                        <th>연동장비 정보</th>
                        <td>{{ configInfoData.cooperationDeviceLabel }}</td>
                      </tr> -->
                    <tr>
                      <th>관리자 (정/부)</th>
                      <td>{{ configInfoData.majorLabel }}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <td>{{ configInfoData.minorLabel }}</td>
                    </tr>
                  </table>
                </el-col>
              </div>
              <div slot="perfFooter">
                <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }}</span>
              </div>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('CPU', ...arguments)" :show-change-btn="false" :eventlevel="cpuData.eventlevel">
              <span slot="perfHeader">CPU</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="cpuViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in cpuData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="cpuData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="cpuViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in cpuData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in cpuData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(cpuData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('MEM', ...arguments)" :show-change-btn="false" :eventlevel="memData.eventlevel">
              <span slot="perfHeader">메모리</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="memViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in memData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="memData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="memViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in memData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in memData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(memData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('PROCESS', ...arguments)" :show-change-btn="false" :eventlevel="processData.eventlevel">
              <el-row style="width: calc(100% - 10px);" type="flex" slot="perfHeader" justify="space-between">
                <span>프로세스</span>
                <el-select v-show="processData.backBody.majorProcCount > 0" v-model="procType" placeholder="데이터가 없습니다." @change="loadBackData('PROCESS')">
                  <el-option v-for="procType in procTypeList" :key="procType.value" :label="procType.label" :value="procType.value" @/>
                </el-select>
              </el-row>
              <!-- BODY -->
              <ul class="event-info-list" v-if="processViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in processData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <el-row style="height:100%;" v-else slot="perfBody">
                <el-table-wrapper v-show="processData.backBody.checkMajor && procType=='majorProc'" style="height:100%;" fit-height :data="processData.backBody.majorProc" :columns="procWidgetTableColumns.majorProc" :show-custom-header="false" :show-search-tool="false" :pagination="false">
                  <template slot-scope="scope" slot="status-slot">
                    <i v-if="scope.row.statusAlive !== null" :class="`${ scope.row.statusAlive === '1' ? 'fas fa-circle state-normal' : 'fas fa-circle text-mini state-abnormal'}`"></i>
                    <el-tooltip v-else effect="dark" content="자원 미수집" placement="top"><span> - </span></el-tooltip>
                  </template>
                  <template slot-scope="scope" slot="cpu-slot">
                    <span>{{ convertValuByUnit(scope.row.procCpuUserate, '%', true, true, false) }}</span>
                  </template>
                  <template slot-scope="scope" slot="memory-slot">
                    <span>{{ convertValuByUnit(scope.row.procMemUsedsize, 'KB', true, true, true) }}</span>
                  </template>
                </el-table-wrapper>
                <el-table-wrapper v-show="!processData.backBody.checkMajor || (processData.backBody.checkMajor && procType !='majorProc')" style="height:100%;" fit-height :data="processData.backBody.majorProc" :columns="procWidgetTableColumns.proc" :show-custom-header="false" :show-search-tool="false" :pagination="false">
                  <template slot-scope="scope" slot="cpu-slot">
                    <span>{{ convertValuByUnit(scope.row.procCpuUserate, '%', true, true, false) }}</span>
                  </template>
                  <template slot-scope="scope" slot="memory-slot">
                    <span>{{ convertValuByUnit(scope.row.procMemUsedsize, 'KB', true, true, true) }}</span>
                  </template>
                </el-table-wrapper>
              </el-row>
              <!-- FOOTER -->
              <ul class="multi" v-if="processViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in processData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in processData.backFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('DISK', ...arguments)" :show-change-btn="false" :eventlevel="diskData.eventlevel">
              <span slot="perfHeader">디스크 사용률 Top 5</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="diskViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in diskData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="diskData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="diskViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in diskData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in diskData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(diskData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('DISKIO', ...arguments)" :show-change-btn="false" :eventlevel="diskioData.eventlevel">
              <span slot="perfHeader">디스크 I/O</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="diskioViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in diskioData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="diskioData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="diskioViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in diskioData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in diskioData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(diskioData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('APPLOG', ...arguments)" :show-change-btn="false" :eventlevel="applogData.eventlevel">
              <span slot="perfHeader">실시간 로그 수</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="applogViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in applogData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <!-- <w-summary-stacked-column-chart v-else slot="perfBody" :series="applogData.backBody"></w-summary-stacked-column-chart> -->
              <w-summary-line-column-chart v-else slot="perfBody" :series="applogData.backBody"></w-summary-line-column-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="applogViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in applogData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="(data, index) in applogData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(diskioData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="24" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('NETIO', ...arguments)" :show-change-btn="false" :eventlevel="netioData.eventlevel">
              <span slot="perfHeader">네트워크 I/O</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="netioViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in netioData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-multi-line-chart v-else slot="perfBody" :series="netioData.backBody" widget-key="SEVER_NETIO"></w-summary-multi-line-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="netioViewIndex === 0" slot="perfFooter">
                <!-- <w-perf-footer-v-info style="width: 50%;" :widget-info="netioData.footer[0].value + '/' + netioData.footer[1].value" :label="'입/출력 패킷 수'" />
                  <w-perf-footer-v-info style="width: 50%;" :widget-info="netioData.footer[2].value + '/' + netioData.footer[3].value" :label="'입/출력 에러패킷 수'" /> -->
                <w-perf-footer-v-info v-for="data in netioData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in netioData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(netioData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="24" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('USERCONN', ...arguments)" :show-change-btn="false" :eventlevel="userconnData.eventlevel">
              <span slot="perfHeader">시스템 접근</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="userconnViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in userconnData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-stacked-column-chart v-else slot="perfBody" :series="userconnData.backBody"></w-summary-stacked-column-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="userconnViewIndex === 0" slot="perfFooter">
                <!--TODO: #49714건으로 임시로 FORNT-FOOTER 데이터 제거. 추후 기획 후 수정 필요함 -->
                <!-- <w-perf-footer-v-info v-for="data in userconnData.frontFooter" :key="data.widgetKey" :widget-info="data" /> -->
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in userconnData.backFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
            </w-perf-widget>
          </el-col>
          <el-col :md="24" :lg="24">
            <w-perf-widget @change-widget-view="changeWidgetView('SESSION', ...arguments)" :show-change-btn="false" :eventlevel="sessionData.eventlevel">
              <span slot="perfHeader">세션</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="sessionViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in sessionData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-session-summary-line-chart v-else slot="perfBody" :series="sessionData.backBody"></w-session-summary-line-chart>
              <!-- FOOTER -->
              <ul class="legend list" v-if="sessionViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in sessionData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in sessionData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(sessionData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
        </div>
      </el-row>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { SERVER } from '@/constants/summary';
import api from '@/api/performance/server/info-table';
import summaryApi from '@/api/performance/summary/summary-info';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../components/PerfWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';
import WPerfFooterVInfo from '../components/PerfFooterVInfo';
import WPerfFooterHInfo from '../components/PerfFooterHInfo';
import WOperationStateInfo from '../components/OperationStateInfo';
import WSummaryLineChart from '../components/SummaryLineChart';
import WSessionSummaryLineChart from '../components/SessionSummaryLineChart';
import WSummaryStackedColumnChart from '../components/SummaryStackedColumnChart';
import WEventInfoWidget from '../components/EventInfoWidget';
import WSummaryLineColumnChart from '../components/SummaryLineColumnChart';
import WSummaryMultiLineChart from '../components/SummaryMultiLineChart';

export default {
  name: 'WPerformanceServerSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterVInfo,
    WPerfFooterHInfo,
    WOperationStateInfo,
    WSummaryLineChart,
    WSummaryStackedColumnChart,
    WEventInfoWidget,
    WSummaryLineColumnChart,
    WSessionSummaryLineChart,
    WSummaryMultiLineChart,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'SMS',
        managetypeKey: '_',
      },
      operationStateParams: {
        rsctypeId: 'RUNNINGSTATUS',
        rscId: 'SERVER_ALIVE',
        rscKey: '_',
      },
      configInfoData: {},
      eventInfoData: {},
      cpuViewIndex: 1,
      memViewIndex: 1,
      diskViewIndex: 1,
      diskioViewIndex: 1,
      sessionViewIndex: 1,
      processViewIndex: 1,
      userconnViewIndex: 1,
      applogViewIndex: 1,
      netioViewIndex: 1,
      cpuData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      memData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      diskData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      diskioData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      sessionData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      processData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      userconnData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      applogData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      netioData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      procType: 'majorProc',
      procTypeList: [
        {
          label: '중요 프로세스',
          value: 'majorProc',
        },
        {
          label: '프로세스 Top 5',
          value: 'all',
        },
      ],
      procWidgetTableColumns: {
        majorProc: [
          {
            prop: 'statusAlive',
            width: 35,
            sortable: false,
            scopedSlot: 'status-slot',
          },
          {
            prop: 'procName',
            label: '중요 프로세스명 (CPU Top5)',
            align: 'left',
            sortable: false,
            showOverflowTooltip: true,
          },
          {
            prop: 'procCpuUserate',
            label: 'CPU(%)',
            width: 70,
            align: 'right',
            scopedSlot: 'cpu-slot',
            sortable: false,
          },
          {
            prop: 'procMemUsedsize',
            label: '메모리(Byte)',
            width: 90,
            align: 'right',
            scopedSlot: 'memory-slot',
            sortable: false,
          },
        ],
        proc: [
          {
            prop: 'procName',
            label: '프로세스명 (CPU Top5)',
            align: 'left',
            sortable: false,
            showOverflowTooltip: true,
          },
          {
            prop: 'procCpuUserate',
            label: 'CPU(%)',
            width: 70,
            align: 'right',
            scopedSlot: 'cpu-slot',
            sortable: false,
          },
          {
            prop: 'procMemUsedsize',
            label: '메모리(Byte)',
            width: 90,
            align: 'right',
            scopedSlot: 'memory-slot',
            sortable: false,
          },
        ],
      },
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    /**
     * 전체 화면 load(Tab 활성화 시, 화면 갱신 시 호출)
     * @author kimjy
     */
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();

        const widgetKeyList = ['CPU', 'MEM', 'DISK', 'DISKIO', 'SESSION', 'PROCESS', 'USERCONN', 'APPLOG', 'NETIO'];
        widgetKeyList.forEach((widgetKey) => {
          const widgetKeyLower = widgetKey.toLowerCase();
          this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
        });
      }
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      api
        .getServerConfigurationInfo({
          objId: this.selectedNode.obj.objId,
        })
        .then((response) => {
          if (response.data.success) {
            const configInfo = response.data.data;
            configInfo.cooperationDeviceLabel = '-';
            if (!isEmpty(configInfo.cooperationDeviceIpaddress)) {
              let statusLabel; // TODO 연동장비 상태에 대한 표현 수정 필요
              if (configInfo.statusType === -1) {
                statusLabel = '자원 미수집';
              } else if (configInfo.statusType === 0) {
                statusLabel = '정상';
              } else {
                statusLabel = '다운';
              }
              configInfo.cooperationDeviceLabel = `${configInfo.cooperationDeviceIpaddress} (${statusLabel})`;
              if (configInfo.cooperationDeviceCount > 1) {
                configInfo.cooperationDeviceLabel += ` 외 ${configInfo.cooperationDeviceCount - 1}개`;
              }
            }

            let majorLabel = EMPTY_TEXT;
            let minorLabel = EMPTY_TEXT;
            if (configInfo.majorName) {
              majorLabel = configInfo.majorDepartment ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
            }
            if (configInfo.minorName) {
              minorLabel = configInfo.minorDepartment ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
            }
            configInfo.majorLabel = majorLabel;
            configInfo.minorLabel = minorLabel;
            configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
            this.configInfoData = configInfo;
          }
        });
    },
    /**
     * 이벤트 정보 조회
     * @author kimjy
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    /**
     * 위젯 전면 또는 후면 데이터 로드
     * @author jeee12
     * @param  {String} widgetKey 위젯 key (rsctypeId)
     * @param  {Integer} viewIndex 위젯 viewIndex
     */
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    /**
     * 전면 데이터 로드 함수
     * @author kimjy
     * @param  {String} widgetType 로드할 위젯 종류
     */
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: SERVER.FRONT[widgetKey],
        rscKey: '_', // 현재 디스크를 제외한 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      api.getSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].frontBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].frontFooter = response.data.data.footer;
        }
      });
    },
    /**
     * 후면 데이터 로드 함수
     * @author kimjy
     * @param  {String} widgetType 로드할 위젯 종류
     */
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: SERVER.BACK[widgetKey],
        rscKey: '_', // 현재 디스크를 제외한 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      if (isEqual(widgetKey, 'PROCESS')) {
        this.processData.backBody.majorProc = [];
        widgetParam.processType = this.procType;
      }
      api.getSummaryRscRsltBackList(widgetParam).then((response) => {
        const result = response.data;
        if (result.success) {
          const footer = result.data.footer;
          if (widgetKey === 'SESSION' && !isEmpty(footer)) {
            footer.forEach((item) => {
              item.label = isEmpty(item.label) ? EMPTY_TEXT : item.label.replace('상태 세션 수', '').trim();
            });
          }

          this[widgetKey.toLowerCase().concat('Data')].backBody = result.data.body;
          this[widgetKey.toLowerCase().concat('Data')].backFooter = footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = result.data.eventlevel;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((e) => {
        if (footer.rsckey) {
          return e.rscInfo.rscKeyName === footer.rscKeyName;
        } else if (e.rscInfo) {
          return e.rscInfo.rsctypeId === footer.rsctypeId && e.rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
    /**
     * @/utils/number/convertValuByUnit 단위 변환 유틸 import
     * <template></template>내에서 사용
     * @author jeee12
     */
    convertValuByUnit,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/server/index.vue